import { render, staticRenderFns } from "./comment-actions.vue?vue&type=template&id=3153ed67&scoped=true&"
import script from "./comment-actions.vue?vue&type=script&lang=js&"
export * from "./comment-actions.vue?vue&type=script&lang=js&"
import style0 from "./comment-actions.vue?vue&type=style&index=0&id=3153ed67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153ed67",
  null
  
)

export default component.exports